<!-- Layout 2: Image Top, Text Centered -->
<div class="hero-container layout-2-container" *ngIf="data?.title || data?.description || data?.buttonText">
  <div class="hero-illustration-center" *ngIf="getImageSrc()">
    <img [src]="getImageSrc()" 
         [alt]="getImageAlt()"
         [ngStyle]="getImageStyles()"
         class="car-illustration">
  </div>
  <div class="hero-content-center">
    <h1 class="hero-title"
        *ngIf="data?.title"
        [style.color]="headingColor"
        [style.font-family]="headingFont"
        [ngStyle]="titleStyles">{{ data?.title }}</h1>
    <p class="hero-subtitle" 
       *ngIf="data?.subtitle"
       [style.color]="paragraphColor"
       [style.font-family]="bodyFont">
      {{ data?.subtitle }}
    </p>
    <p class="hero-description"
       *ngIf="data?.description"
       [style.color]="paragraphColor"
       [style.font-family]="bodyFont">
      {{ data?.description }}
    </p>
    <button class="hero-btn" 
            *ngIf="data?.buttonText"
            [style.background-color]="primaryColor"
            [style.color]="'#FFFFFF'"
            (click)="onButtonClick(data?.buttonLink, $event)">{{ data?.buttonText }}</button>
  </div>
</div>

